<template>
  <CommonPopup
    title="Recebido com sucesso"
    confirmText="Confirmar"
    @confirm="receberBonus"
  >
    <template #default>
      <img src="@a/assets/images/i_money2.png" class="size-15 my-4" alt="" />
      <p class="text-14 font-[500] leading-20 text-center">
        Parabéns por ganhar
        <span class="text-[var(--theme-primary)] text-[15px]"
          >R$:{{ formatter().format(+amount!) }}</span
        >
        em fichas de bônus
      </p>
    </template>
  </CommonPopup>
</template>

<script setup lang="ts">
import CommonPopup from "@a/components/commonPopup/index.vue";
import { receber } from "@/hooks/useActivity";
import { formatter } from "@/utils";

const { activityId, onSuccess } = defineProps<{
  activityId: string;
  amount?: number | string;
  onSuccess?: () => void;
}>();

const receberBonus = async () => {
  await receber({
    flowType: "UserRebateReward",
    activityId,
  });

  onSuccess?.();
};
</script>
